import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CardComponent } from '../card/card.component';
import { CardMessageComponent } from '../card-message/card-message.component';
import { CardModel, CardState } from '../games/models/game-view.model';

@Component({
    selector: 'app-card-holder',
    standalone: true,
    imports: [CommonModule, CardComponent, CardMessageComponent],
    templateUrl: './card-holder.component.html',
    styleUrl: './card-holder.component.scss'
})
export class CardHolderComponent {
    @Input()
    card!: CardModel;

    @Input()
    compact = false;

    @Input()
    rotated = false;

    protected readonly CardState = CardState;
}
